/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import MetaData from '@gerenciatd/next.app-controller.meta-data';
import Header from '@gerenciatd/next.components.header-r';
import Footer from '@gerenciatd/next.components.footer';
import { actions as mainActions } from '@gerenciatd/next.app-controller.reducers-sagas.main-reducer-r';
import { END } from 'redux-saga';
import { wrapper } from '@/store';
import {
  getDescriptions,
  getMoreInfo,
  getItemsAdicionales,
} from '../../public/generic/devices';
import { openModalCondiciones } from '../../public/generic/modals';

import {
  ButtonLink,
  ButtonPrimary,
  ButtonSecondary,
  MediaCard,
  GridLayout,
  Tag,
  Image,
  Box,
  ResponsiveLayout,
  Stack,
  Text5,
  Text6,
  Text7,
  Text1,
  Text4,
  Carousel,
  dialog,
  Divider,
  ButtonLayout,
  TextLink,
  Inline,
  IconLightningLight,
  IconVideogamesLight,
  IconOnlineReloadLight,
  IconVideoLight,
  Text3,
  Text2,
  useScreenSize,
  Tabs,
  PosterCard,
  skinVars,
} from '@telefonica/mistica';

var numSteps = 20.0;

var boxElement;
var prevRatio = 0.0;
var observercreated = false;

function createObserver() {
  var observer;

  var options = {
    root: null,
    rootMargin: '0px',
    threshold: buildThresholdList(),
  };

  observer = new IntersectionObserver(handleIntersect, options);
  observer.observe(boxElement);
}

function buildThresholdList() {
  var thresholds = [];

  for (var i = 1.0; i <= numSteps; i++) {
    var ratio = i / numSteps;
    thresholds.push(ratio);
  }

  thresholds.push(0);
  return thresholds;
}

function handleIntersect(entries, observer) {
  entries.forEach(function (entry) {
    let sticky_div = document.getElementById('sticky_div');
    if (document.querySelector('.floating_cta_guide') != undefined) {
      if (sticky_div != undefined) {
        if (entry.intersectionRatio > prevRatio) {
          sticky_div.classList.remove('active');
        } else {
          sticky_div.classList.add('active');
        }
        prevRatio = entry.intersectionRatio;
      }
    }
  });
}

function createStat(e) {
  e.preventDefault();
  let a = e.target.closest('.createstat');
  const classList = a.classList;
  for (let i = 0; i < classList.length; i++) {
    if (classList[i].indexOf('tealium_clic_') > -1) {
      dataLayerGTM.push({
        event: 'asyncGTM',
        GAcategory: 'Interaccion',
        GAaction: 'Clic',
        GAlabel: classList[i].replace('tealium_clic_', ''),
      });
    }
  }
}

function createStatBtn(e) {
  let a = e.target.closest('.createstatbtn');
  const classList = a.classList;
  for (let i = 0; i < classList.length; i++) {
    if (classList[i].indexOf('tealium_clic_') > -1) {
      dataLayerGTM.push({
        event: 'asyncGTM',
        GAcategory: 'Interaccion',
        GAaction: 'Clic',
        GAlabel: classList[i].replace('tealium_clic_', ''),
      });
    }
  }
}

function setPrecios(
  val,
  devices,
  others,
  setTabText,
  setPrecioBanner1,
  setPrecioBanner2
) {
  console.log(val, devices);
  let preciocol = 'preciopromo';
  let urlcol = 'urlpromo';
  let classloquiero = 'classpromo';
  let classmasinfo = 'classinfopromo';
  let tabtxtinfo = (
    <Stack space={16} className="mt24">
      <Text1 as="h4" textAlign="center" color={skinVars.colors.textSecondary}>
        Si eres cliente miMovistar, selecciona esta consola como primer
        dispositivo. Si no lo eres, contrata tu plan ahora.
      </Text1>
    </Stack>
  );

  setPrecioBanner1('6,50€');
  setPrecioBanner2('6,50€');
  if (val == 1) {
    preciocol = 'precionopromo';
    urlcol = 'urlnopromo';
    classloquiero = 'classnopromo';
    classmasinfo = 'classinfonopromo';
    tabtxtinfo = (
      <Stack space={16} className="mt24">
        <Text1 as="h4" textAlign="center" color={skinVars.colors.textSecondary}>
          Consigue ahora esta consola como dispositivo adicional desde tu Área
          Cliente.
        </Text1>
      </Stack>
    );
    setPrecioBanner1('15,00€');
    setPrecioBanner2('15,00€');
  }
  setTabText(tabtxtinfo);
  for (let i = 0; i < devices.length; i++) {
    devices[i]['precio'] = devices[i][preciocol];
    devices[i]['url'] = devices[i][urlcol];
    devices[i]['classloquiero'] = devices[i][classloquiero];
    console.log(urlcol);
  }
  for (let i = 0; i < others.length; i++) {
    others[i]['precio'] = others[i][preciocol];
    others[i]['url'] = others[i][urlcol];
    others[i]['classloquiero'] = others[i][classloquiero];

    let moreinfo = getMoreInfo(others[i]['alias']);
    if (moreinfo == '') {
      others[i]['moreinfo'] = false;
    } else {
      others[i]['moreinfo'] = (
        <ButtonSecondary
          small
          href={getMoreInfo(others[i]['alias'])}
          className={others[i][classmasinfo]}
        >
          Más información
        </ButtonSecondary>
      );
    }
  }
}

const SeriesX = ({ headerProps, breadcrumbsProps, seoInfo }) => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [imageUrl, setImageUrl] = React.useState(null);
  const [devices, setDevices] = React.useState(null);
  const [others, setDevicesOthers] = React.useState(null);
  const [tabIndex, setTabIndex] = React.useState(null);
  const [tabText, setTabText] = React.useState(null);
  const [preciobanner1, setPrecioBanner1] = React.useState(null);
  const [preciobanner2, setPrecioBanner2] = React.useState(null);
  const [itemsincluye, setItemsIncluye] = React.useState(null);
  const dispatch = useDispatch();
  
  useEffect(() => {
    dispatch(
      mainActions.setCurrentSeo(seoInfo)
    );
  },[]);

  React.useEffect(() => {
    setTabIndex(0);
    document.addEventListener('scroll', (event) => {
      boxElement = document.querySelector('.floating_cta_guide');
      if (boxElement != undefined && observercreated == false) {
        observercreated = true;
        createObserver();
      }
    });

    document.querySelectorAll('.createstat').forEach(function (el, i) {
      el.addEventListener('click', createStat);
    });

    fetch(
      'https://catalogue.col.movistar.es/api/terminal/v1/getAllItem?segment=FUSION_AV&type=gaming'
    )
      .then((response) => response.json())
      .then((data) => {
        //setImageUrl(dog.message); // ⬅️ Guardar datos

        //const data = JSON.parse(req.responseText);

        const category = 'gaming';
        const orderelements = [];
        let maxorder = 0;
        let dispositivos = [];
        let otros = [];

        let descripciones = getDescriptions();

        for (let i = 0; i < data[category].length; i++) {
          let dispositivo = {};
          let order = orderelements.indexOf(data[category][i]['alias']);
          if (order == -1) {
            order = orderelements.length + maxorder;
            maxorder++;
          }

          dispositivo['alias'] = data[category][i]['alias'];
          dispositivo['name'] = data[category][i]['name'];
          dispositivo['order'] = order;

          if (descripciones[dispositivo['alias']] != undefined) {
            dispositivo['descripcion'] = descripciones[dispositivo['alias']];
          } else {
            dispositivo['descripcion'] = '';
          }
          dispositivo['descripcion'] = '';

          for (let x = 0; x < data[category][i]['offers'].length; x++) {
            if (data[category][i]['offers'][x]['main'] == true) {
              dispositivo['offer'] = data[category][i]['offers'][x];
            }
          }

          let preciopromo = 1000000;
          let precionopromo = 1000000;

          if (parseFloat(dispositivo['offer']['pvp_fusion_av']) < preciopromo) {
            preciopromo = parseFloat(
              dispositivo['offer']['pvp_fusion_av'].replace(',', '.')
            );
          }

          if (
            parseFloat(dispositivo['offer']['pvp_fusion_av']) < precionopromo
          ) {
            precionopromo = parseFloat(
              dispositivo['offer']['pvp_fusion_av'].replace(',', '.')
            );
          }

          if (
            parseFloat(dispositivo['offer']['pvp_fusion_av_promo']) <
            preciopromo
          ) {
            preciopromo = parseFloat(
              dispositivo['offer']['pvp_fusion_av_promo'].replace(',', '.')
            );
          }

          if (parseFloat(dispositivo['offer']['pvp_fusion_bv']) < preciopromo) {
            preciopromo = parseFloat(
              dispositivo['offer']['pvp_fusion_bv'].replace(',', '.')
            );
          }

          if (
            parseFloat(dispositivo['offer']['pvp_fusion_bv']) < precionopromo
          ) {
            precionopromo = parseFloat(
              dispositivo['offer']['pvp_fusion_bv'].replace(',', '.')
            );
          }

          if (
            parseFloat(dispositivo['offer']['pvp_fusion_bv_promo']) <
            preciopromo
          ) {
            preciopromo = parseFloat(
              dispositivo['offer']['pvp_fusion_bv_promo'].replace(',', '.')
            );
          }

          if (parseFloat(dispositivo['offer']['pvp_fusion_mv']) < preciopromo) {
            preciopromo = parseFloat(
              dispositivo['offer']['pvp_fusion_mv'].replace(',', '.')
            );
          }

          if (
            parseFloat(dispositivo['offer']['pvp_fusion_mv']) < precionopromo
          ) {
            precionopromo = parseFloat(
              dispositivo['offer']['pvp_fusion_mv'].replace(',', '.')
            );
          }

          if (
            parseFloat(dispositivo['offer']['pvp_fusion_mv_promo']) <
            preciopromo
          ) {
            preciopromo = parseFloat(
              dispositivo['offer']['pvp_fusion_mv_promo'].replace(',', '.')
            );
          }

          dispositivo['preciopromo'] = preciopromo;
          dispositivo['precionopromo'] = precionopromo;
          dispositivo['precio'] = preciopromo;
          dispositivo['precioOriginal'] = dispositivo['offer']['originalPrice'];
          dispositivo['image'] =
            'https://movistar.es/' + dispositivo['offer']['imgs'][0];
          dispositivo['urlpromo'] =
            'https://www.movistar.es/particulares/mimovistar/elige-dispositivo?deviceType=gaming&flyOutAlias=' +
            dispositivo['alias'] +
            '&pid=clic-boton-meinteresa';
          dispositivo['urlnopromo'] =
            'https://www.movistar.es/particulares/mimovistar/elige-dispositivo?deviceType=gaming&flyOutAlias=' +
            dispositivo['alias'] +
            '&tabId=dispositivosadicionales&pid=clic-boton-meinteresa';

          dispositivo['url'] = dispositivo['urlpromo'];

          let stamps = 'promo';
          let stampslbl = '';
          let labels = '';
          let tagsdef = [];
          for (let x = 0; x < dispositivo['offer']['stamps'].length; x++) {
            if (dispositivo['offer']['stamps'][x]['kind'] != '') {
              stamps = dispositivo['offer']['stamps'][x]['kind'];
              stampslbl =
                dispositivo['offer']['stamps'][x]['text']
                  .charAt(0)
                  .toUpperCase() +
                dispositivo['offer']['stamps'][x]['text']
                  .slice(1)
                  .toLowerCase();
              if (stamps == 'promocion') {
                stamps = 'promo';
              } else if (stamps == 'novedad') {
                stamps = 'active';
              }
              tagsdef.push(
                <Tag type={stamps} style={{ textTransform: 'capitalize' }}>
                  {stampslbl}
                </Tag>
              );
              labels += stampslbl;
            }
          }

          dispositivo['tags'] = labels;

          dispositivo['tagstype'] = stamps;
          dispositivo['tagsdef'] = tagsdef;

          if (dispositivo['alias'].indexOf('series-x') > -1) {
            dispositivo['classpromo'] =
              'tealium_clic_PA-gaming-elige-pack-' +
              dispositivo['alias'] +
              '-loquiero createstatbtn';
            dispositivo['classnopromo'] =
              'tealium_clic_PA-gaming-elige-pack-' +
              dispositivo['alias'] +
              '-loquiero-adicional createstatbtn';
            dispositivo['classinfopromo'] =
              'tealium_clic_PA-gaming-elige-pack-' +
              dispositivo['alias'] +
              '-masinformacion createstatbtn';
            dispositivo['classinfonopromo'] =
              'tealium_clic_PA-gaming-elige-pack-' +
              dispositivo['alias'] +
              '-masinformacion-adicional createstatbtn';
            dispositivo['classloquiero'] = dispositivo['classpromo'];
            dispositivo['classmasinfo'] = dispositivo['classinfopromo'];

            dispositivo['moreinfo'] = false;

            dispositivos.push(dispositivo);
          } else {
            dispositivo['classpromo'] =
              'tealium_clic_PA-gaming-te-puede-interesar-' +
              dispositivo['alias'] +
              '-loquiero createstatbtn';
            dispositivo['classnopromo'] =
              'tealium_clic_PA-gaming-te-puede-interesar-' +
              dispositivo['alias'] +
              '-loquiero-adicional createstatbtn';
            dispositivo['classinfopromo'] =
              'tealium_clic_PA-gaming-te-puede-interesar-' +
              dispositivo['alias'] +
              '-masinformacion createstatbtn';
            dispositivo['classinfonopromo'] =
              'tealium_clic_PA-gaming-te-puede-interesar-' +
              dispositivo['alias'] +
              '-masinformacion-adicional createstatbtn';
            dispositivo['classloquiero'] = dispositivo['classpromo'];
            dispositivo['classmasinfo'] = dispositivo['classinfopromo'];

            let moreinfo = getMoreInfo(dispositivo['alias']);
            if (moreinfo == '') {
              dispositivo['moreinfo'] = false;
            } else {
              dispositivo['moreinfo'] = (
                <ButtonSecondary
                  small
                  href={getMoreInfo(dispositivo['alias'])}
                  className={dispositivo['classmasinfo']}
                >
                  Más información
                </ButtonSecondary>
              );
            }

            otros.push(dispositivo);
          }
        }

        dispositivos.sort(function (a, b) {
          return a['order'] - b['order'];
        });

        if (dispositivos.length > 3) {
          setItemsIncluye(4);
        } else {
          setItemsIncluye(0);
        }

        setDevices(dispositivos);
        setDevicesOthers(otros);
        setTabText(
          <Stack space={16} className="mt24">
            <Text1
              as="h4"
              textAlign="center"
              color={skinVars.colors.textSecondary}
            >
              Si eres cliente miMovistar, selecciona esta consola como primer
              dispositivo. Si no lo eres, contrata tu plan ahora.
            </Text1>
          </Stack>
        );
        setPrecioBanner1('6,50€');
        setPrecioBanner2('6,50€');
        setIsLoading(false);

        getItemsAdicionales(dispositivos, otros);

        document.querySelectorAll('.createstatbtn').forEach(function (el, i) {
          el.addEventListener('click', createStatBtn);
        });
      });
  }, []);

  if (isLoading) {
    // ⬅️ si está cargando, mostramos un texto que lo indique
    return '';
  }

  const { isDesktopOrBigger } = useScreenSize();

  let pathUrlImg;
  if(window.location.hostname.indexOf('127.0.0.1') >= 0 || 
  window.location.hostname.indexOf('col10mgmt.tsm.inet') >= 0 ||
  window.location.hostname.indexOf('qa.cms.col.movistar.es') >= 0)
  {
    pathUrlImg = "https://col10mgmt.tsm.inet";
  }else{
    pathUrlImg = "https://www.movistar.es";
  }

  return (
    <>
      <MetaData seoInfo={seoInfo} />
      <Header {...breadcrumbsProps} {...headerProps} />
      <>
        <div>
          <div className="headbanner">
            <ResponsiveLayout className="responsivelayout">
              <Box paddingY={isDesktopOrBigger ? 0 : 24} className="gridbanner">
                <Carousel
                  autoplay={{ time: 5000, loop: true }}
                  withBullets
                  itemsPerPage={{ desktop: 1 }}
                  items={Array.from({ length: 1 }, (_, idx) => (
                    <div className={'griditem' + idx.toString()}>
                      <GridLayout
                        key={idx.toString()}
                        template="6+6"
                        right={
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                            }}
                            className="bannerimage"
                          >
                            <Image
                              loadingFallback={false}
                              noBorderRadius
                              height={430}
                              alt="xbox series x"
                              src={
                                [
                                  `${process.env.NEXT_PUBLIC_CDN}/estaticos/img/banner_series_x.jpg`,
                                ][idx]
                              }
                            />
                            <Image
                              loadingFallback={false}
                              noBorderRadius
                              alt="xbox series x"
                              src={
                                [
                                  `${process.env.NEXT_PUBLIC_CDN}/estaticos/img/banner_series_x_mov.jpg`,
                                ][idx]
                              }
                            />
                          </div>
                        }
                        left={
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              textAlign: isDesktopOrBigger ? 'left' : 'center',
                              height: '100%',
                              width: '95%',
                              margin: '0 auto',
                              paddingRight: isDesktopOrBigger ? 24 : 0,
                              order: isDesktopOrBigger ? 0 : 2,
                            }}
                          >
                            <Stack space={12}>
                              <Stack space={1}>
                                <Text7
                                  as="h1"
                                  color={skinVars.colors.textPrimaryInverse}
                                >
                                  {
                                    [
                                      'Xbox Series X + Forza Horizon 5 Premium Edition + mando adicional blanco',
                                    ][idx]
                                  }
                                </Text7>
                              </Stack>

                              <div style={{display:"none"}}>
                                <Text3
                                  color={skinVars.colors.textPrimaryInverse}
                                >
                                  Desde
                                </Text3>
                                &nbsp;&nbsp;
                                <Text5 color={skinVars.colors.textSecondary}>
                                  <s>599,99€</s>
                                </Text5>
                                &nbsp;&nbsp;
                                <Text5
                                  color={skinVars.colors.textPrimaryInverse}
                                >
                                  {preciobanner1}/mes
                                </Text5>
                                &nbsp;&nbsp;
                                <Text3
                                  color={skinVars.colors.textPrimaryInverse}
                                >
                                  <b>con miMovistar</b>
                                </Text3>
                              </div>

                              <Stack space={0} className="topbutton">
                                <ButtonPrimary
                                  onPress={(e) => {
                                    e.preventDefault;
                                    document
                                      .querySelector('.preciotabsguia .guia')
                                      .scrollIntoView({
                                        block: 'start',
                                        behavior: 'smooth',
                                      });
                                  }}
                                  href={'#preciotabs'}
                                >
                                  ¡Lo quiero!
                                </ButtonPrimary>
                              </Stack>
                              <Text1 color={skinVars.colors.textPrimaryInverse}>
                                {/* Y si no eres cliente, accede a la oferta{' '}
                                <TextLink
                                  href="https://www.movistar.es/particulares/mimovistar"
                                  newTab
                                >
                                  configurando
                                </TextLink>{' '}
                                cualquiera de los planes miMovistar,
                                seleccionando la{' '}
                                {['Xbox Series X', 'Xbox Series X'][idx]} como
                                dispositivo. */}
                                <br />
                                <TextLink onPress={openModalCondiciones}>
                                  *Ver condiciones
                                </TextLink>
                              </Text1>
                            </Stack>
                          </div>
                        }
                      >
                        <Inline alignItems="center" space="between"></Inline>
                      </GridLayout>
                    </div>
                  ))}
                />
              </Box>
            </ResponsiveLayout>
          </div>
          <ResponsiveLayout>
            <Box paddingY={32}>
              <Stack space={24}>
                <Stack space={16}>
                  <Text6 as="h2" textAlign="center">
                    Llévate hasta 5 dispositivos con miMovistar
                  </Text6>
                </Stack>
              </Stack>
            </Box>
          </ResponsiveLayout>

          <ResponsiveLayout>
            <div className="preciotabsguia">
              <div className="guia"></div>
            </div>
            <Stack space={0} className="preciotabs">
              <Tabs
                selectedIndex={tabIndex}
                onChange={(val) => {
                  setTabIndex(val);
                  setPrecios(
                    val,
                    devices,
                    others,
                    setTabText,
                    setPrecioBanner1,
                    setPrecioBanner2
                  );
                }}
                tabs={[
                  {
                    text: 'Es mi primer dispositivo miMovistar',
                  },
                  {
                    text: 'Ya tengo un dispositivo miMovistar',
                  },
                ]}
              />
            </Stack>
          </ResponsiveLayout>
          <ResponsiveLayout className="tabcontent">
            <Text2>{tabText}</Text2>
          </ResponsiveLayout>
          <ResponsiveLayout>
            <Box paddingTop={64} paddingBottom={32}>
              <Stack space={24}>
                <Stack space={24}>
                  <Text6 as="h2" textAlign="center">
                    Elige tu pack de Xbox Series X al mejor precio
                  </Text6>
                </Stack>
                <Stack space={0}>
                  <div
                    className="carrouselincluye mt24"
                    style={{ justifyContent: 'center' }}
                  >
                    <Carousel
                      style={{ justifyContent: 'center' }}
                      itemsPerPage={{ desktop: itemsincluye }}
                      withBullets
                      items={devices.map((item, i) => (
                        <MediaCard
                          key={i}
                          headline={item['tagsdef'].map((tag, x) => tag)}
                          pretitle=""
                          title={item['name']}
                          subtitle={
                            <Text2
                              color={skinVars.colors.textSecondary}
                              color={skinVars.colors.textSecondary}
                            >
                              {item['descripcion']}
                            </Text2>
                          }
                          description={
                            <div>
                              <Text2>Desde</Text2>
                              <br />
                              <Text4 color={skinVars.colors.textSecondary}>
                                <s>{item['precioOriginal']}€</s>
                              </Text4>{' '}
                              <Text5>{item['precio']}€</Text5>
                              <Text2>/mes</Text2>
                              <br />
                              <Text2 color={skinVars.colors.textSecondary}>
                                con miMovistar
                              </Text2>
                            </div>
                          }
                          media={
                            <img
                              src={item['image']}
                              style={{
                                maxHeight: '180px',
                                objectFit: 'contain',
                                padding: '10px 0',
                                backgroundColor: '#ccc',
                              }}
                            />
                          }
                          button={
                            <ButtonPrimary
                              small
                              className={item['classloquiero']}
                              href={item['url']}
                            >
                              ¡Lo quiero!
                            </ButtonPrimary>
                          }
                        />
                      ))}
                    />{' '}
                  </div>
                </Stack>
              </Stack>
            </Box>
          </ResponsiveLayout>
          <ResponsiveLayout>
            <Box
              paddingTop={isDesktopOrBigger ? 60 : 40}
              paddingBottom={isDesktopOrBigger ? 40 : 20}
            >
              <Stack space={0}>
                <Text6 as="h2" textAlign="center">
                  ¿Qué incluye el pack de Xbox Series X + Mineral Camo + <br />
                  Call of Duty: Modern Warfare II?
                </Text6>
              </Stack>
            </Box>

            <Stack space={0}>
              <Inline space={0} className="poster3">
                <Stack space={24}>
                  <PosterCard
                    aspectRatio="7:10"
                    title="Xbox Series X"
                    description={
                      <ul>
                        <li>Consola Xbox Series X</li>
                        <li>Mando inalámbrico</li>
                        <li>Dos pilas AA</li>
                        <li>Cable HDMI de ultra alta velocidad</li>
                        <li>Cable de alimentación</li>
                        <li>Guía de inicio rápido</li>
                      </ul>
                    }
                    backgroundImage={`${process.env.NEXT_PUBLIC_CDN}/estaticos/img/incluye1.png`}
                  />
                </Stack>
                <Stack space={24}>
                  <PosterCard
                    aspectRatio="7:10"
                    title="Mineral Camo Special Edition"
                    description={
                      <ul>
                        <li>Mando inalámbrico adicional</li>
                        <li>Patrón de camuflaje azul mineral</li>
                        <li>
                          Compatible con consola, PC y dispositivos móviles
                        </li>
                        <li>Agarre texturizado en los gatillos</li>
                      </ul>
                    }
                    backgroundImage={`${process.env.NEXT_PUBLIC_CDN}/estaticos/img/incluye2.png`}
                  />
                </Stack>
                <Stack space={24}>
                  <PosterCard
                    aspectRatio="7:10"
                    title="Call of Duty: Modern Warfare II"
                    description={
                      <ul>
                        <li>Modo individual y multijugador</li>
                        <li>Jugabilidad de última generación</li>
                        <li>Icónicos operadores de Fuerza operativa 141</li>
                        <li>Novedoso manejo de armas</li>
                        <li>Avanzado sistema de IA</li>
                      </ul>
                    }
                    backgroundImage={`${process.env.NEXT_PUBLIC_CDN}/estaticos/img/incluye3.png`}
                  />
                </Stack>
              </Inline>
            </Stack>
          </ResponsiveLayout>
          <ResponsiveLayout>
            <Box
              paddingTop={isDesktopOrBigger ? 80 : 40}
              paddingBottom={isDesktopOrBigger ? 40 : 20}
            >
              <Stack space={0}>
                <Text6 as="h2" textAlign="center">
                  ¿Qué incluye el pack de Xbox Series X + Horizon 5 <br />
                  Premium Edition + Mando adicional blanco?
                </Text6>
              </Stack>
            </Box>

            <Stack space={0}>
              <Inline space={0} className="poster3">
                <Stack space={24}>
                  <PosterCard
                    aspectRatio="7:10"
                    title="Xbox Series X"
                    description={
                      <ul>
                        <li>Consola Xbox Series X</li>
                        <li>Mando inalámbrico</li>
                        <li>Dos pilas AA</li>
                        <li>Cable HDMI de ultra alta velocidad</li>
                        <li>Cable de alimentación</li>
                        <li>Guía de inicio rápido</li>
                      </ul>
                    }
                    backgroundImage={`${process.env.NEXT_PUBLIC_CDN}/estaticos/img/incluye1.png`}
                  />
                </Stack>
                <Stack space={24}>
                  <PosterCard
                    aspectRatio="7:10"
                    title="Gamepad White"
                    description={
                      <ul>
                        <li>Mando inalámbrico adicional de color blanco</li>
                        <li>
                          Compatible con consola, PC y dispositivos móviles
                        </li>
                        <li>Hasta 40 horas de autonomía</li>
                        <li>Agarre texturizado y cruceta híbrida</li>
                      </ul>
                    }
                    backgroundImage={`${process.env.NEXT_PUBLIC_CDN}/estaticos/img/incluye5.png`}
                  />
                </Stack>
                <Stack space={24}>
                  <PosterCard
                    aspectRatio="7:10"
                    title="Forza Horizon 5 Premium Edition"
                    description={
                      <ul>
                        <li>Forza Horizon 5</li>
                        <li>Forza Horizon 5: Hot Wheels</li>
                        <li>Forza Horizon 5: Rally Adventure</li>
                        <li>Paquete de bienvenida de Forza Horizon 5</li>
                        <li>Suscripción VIP de Forza Horizon 5</li>
                        <li>Paquete de coches de Forza Horizon 5</li>
                      </ul>
                    }
                    backgroundImage={`${process.env.NEXT_PUBLIC_CDN}/estaticos/img/incluye6.png`}
                  />
                </Stack>
              </Inline>
            </Stack>
          </ResponsiveLayout>
          <ResponsiveLayout fullWidth>
            <div
              style={{
                background: skinVars.colors.backgroundAlternative,
                marginTop: '40px',
              }}
            >
              <ResponsiveLayout>
                <Box paddingY={isDesktopOrBigger ? 44 : 24}>
                  <div style={{ textAlign: 'center' }}>
                    <Stack space={64}>
                      <Text6 textAlign="center" as="h2">
                        Xbox Series X: la consola de Xbox más rápida <br />y
                        potente de la historia
                      </Text6>
                      <Inline
                        space={10}
                        className={isDesktopOrBigger ? 'grid2' : 'grid2hidden'}
                      >
                        <Stack space={24}>
                          <img
                            className="imgcard"
                            src={`${process.env.NEXT_PUBLIC_CDN}/estaticos/img/imggrid1.jpg`}
                            alt="consola xbox series x potente y rápida"
                          />
                        </Stack>
                        <Stack space={24}>
                          <img
                            className="imgcard"
                            src={`${process.env.NEXT_PUBLIC_CDN}/estaticos/img/imggrid2.jpg`}
                            alt="precio del xbox series x"
                          />
                        </Stack>
                      </Inline>
                      <Inline
                        space={isDesktopOrBigger ? 24 : 0}
                        className="grid4"
                      >
                        {Array.from({ length: 4 }, (_, idx) => (
                          <Stack space={24} key={idx.toString()}>
                            {
                              [
                                <IconLightningLight size={48} />,
                                <IconVideogamesLight size={48} />,
                                <IconOnlineReloadLight size={48} />,
                                <IconVideoLight size={48} />,
                              ][idx]
                            }
                            <Stack space={8} className="text-center">
                              <Text5 style={{ textAlign: 'center' }}>
                                {
                                  [
                                    '12 teraflops de potencia',
                                    '4K en juegos',
                                    'Hasta 120 FPS',
                                    'Alto rango dinámico 8K HDR',
                                  ][idx]
                                }
                              </Text5>
                              <Text1
                                color={skinVars.colors.textPrimary}
                                textAlign="center"
                              >
                                {
                                  [
                                    <span>
                                      Nueva tarjeta gráfica con{' '}
                                      <b>12 teraflops de potencia</b>, lo que
                                      supone un mayor rendimiento de la consola.
                                    </span>,
                                    <span>
                                      Detalles increíbles con{' '}
                                      <b>auténtico 4K y sonido espacial 3D</b>{' '}
                                      en mundos más brillantes y personajes
                                      ultranítidos.
                                    </span>,
                                    <span>
                                      Alcanza velocidades de{' '}
                                      <b>hasta 120 fotogramas por segundo</b>{' '}
                                      con la increíble explosión visual que
                                      ofrece HDR.
                                    </span>,
                                    <span>
                                      Disfruta de un{' '}
                                      <b>brillo y color sin precedentes</b> en
                                      tus partidas con una imagen notablemente
                                      más completa, rica y realista.
                                    </span>,
                                  ][idx]
                                }
                              </Text1>
                            </Stack>
                          </Stack>
                        ))}
                      </Inline>
                    </Stack>
                  </div>
                </Box>
              </ResponsiveLayout>
            </div>
          </ResponsiveLayout>

          <ResponsiveLayout fullWidth>
            <div>
              <ResponsiveLayout>
                <Box paddingTop={isDesktopOrBigger ? 96 : 40}>
                  <Stack space={64}>
                    <div style={{ textAlign: 'center' }}>
                      <Stack space={16}>
                        <Text6 textAlign="center" as="h2">
                          Características técnicas de la Xbox Series X
                        </Text6>
                        <Text4 color={skinVars.colors.textSecondary}>
                          Aquí tienes el detalle de la que será tu nueva
                          consola.
                        </Text4>
                      </Stack>
                    </div>
                    <Box className="techTable">
                      {Array.from({ length: 6 }, (_, idx) => (
                        <Stack space={0} key={idx.toString()}>
                          <Box paddingY={16}>
                            <Inline space="between" className="techTableRow">
                              <Text3>
                                {
                                  [
                                    'Procesador',
                                    'Memoria y almacenamiento',
                                    'Funcionalidades de vídeo',
                                    'Funcionalidades de sonido',
                                    'Puertos y conectividad',
                                    'Accesorios que incluye la caja',
                                  ][idx]
                                }
                              </Text3>
                              <div style={{ textAlign: 'right' }}>
                                <Stack space={0}>
                                  <Text2 color={skinVars.colors.textSecondary}>
                                    {
                                      [
                                        'CPU Zen 2 de 8 núcleos a 3,8 GHz',
                                        'GDDR6 de 16 GB',
                                        'Auténtico 4K',
                                        'Dolby Digital 5.1',
                                        'HDMI. 1 puerto HDMI 2.1',
                                        'Consola Xbox Series X',
                                      ][idx]
                                    }
                                  </Text2>
                                  <Text2 color={skinVars.colors.textSecondary}>
                                    {
                                      [
                                        'GPU de 12 TERAFLOPS, 52 CU a 1,825 GHz',
                                        '10 GB a 560 GB/s, 6 GB a 336 GB/s, SSD NVME personalizado de 1TB',
                                        'HDR de hasta 8K',
                                        'DTS 5.1',
                                        'USB. 3 puertos USB 3.1 Gen 1',
                                        '+ Mando inalámbrico Xbox',
                                      ][idx]
                                    }
                                  </Text2>
                                  <Text2 color={skinVars.colors.textSecondary}>
                                    {
                                      [
                                        undefined,
                                        undefined,
                                        '4k UHD Blue-ray',
                                        'Dolby TrueHD con Atmos',
                                        'Red inalámbrica. Banda dual de 802.11ac',
                                        '+ Cable HDMI de ultra alta velocidad',
                                      ][idx]
                                    }
                                  </Text2>
                                  <Text2 color={skinVars.colors.textSecondary}>
                                    {
                                      [
                                        undefined,
                                        undefined,
                                        'Hasta 120 FPS',
                                        undefined,
                                        'Ethernet. 802.3 10/100/1000',
                                        undefined,
                                      ][idx]
                                    }
                                  </Text2>
                                </Stack>
                              </div>
                            </Inline>
                          </Box>
                          <Divider />
                        </Stack>
                      ))}
                    </Box>
                  </Stack>
                </Box>
              </ResponsiveLayout>
            </div>
          </ResponsiveLayout>

          <ResponsiveLayout fullWidth>
            <div
              style={{
                background: skinVars.colors.backgroundAlternative,
                marginTop: '40px',
              }}
            >
              <ResponsiveLayout>
                <Box paddingY={64}>
                  <Stack space={64}>
                    <Text6 textAlign="center" as="h2">
                      Solo con Movistar, prueba un mes gratis de los <br />
                      mejores videojuegos
                    </Text6>
                    <Stack  space={0} className="inversemob">
                      <GridLayout
                        template="6+6"
                        left={
                          <img
                            className="imgcard"
                            src={`${pathUrlImg}/estaticos/imagenes/gaming/x-box/dispositivos.png`}
                            alt="los mejores videojuegos con un mes gratis en Movistar"
                          />
                        }
                        right={
                          <Stack space={24}>
                            <Text3 as="p" color={skinVars.colors.textSecondary}>
                              Suscríbete a{' '}
                              <b>Xbox Game Pass Ultimate de Movistar</b>, el
                              mejor complemento para tu Xbox Series X 
                            </Text3>
                            <ul
                              className="listxgpu"
                              style={{ color: skinVars.colors.textSecondary }}
                            >
                              <li>
                                <img
                                  src={`${process.env.NEXT_PUBLIC_CDN}/estaticos/img/check-regular.svg`}
                                />{' '}
                                Cientos de juegos
                              </li>
                              <li>
                                <img
                                  src={`${process.env.NEXT_PUBLIC_CDN}/estaticos/img/check-regular.svg`}
                                />{' '}
                                Nuevos lanzamientos cada mes 
                              </li>
                              <li>
                                <img
                                  src={`${process.env.NEXT_PUBLIC_CDN}/estaticos/img/check-regular.svg`}
                                />{' '}
                                Incluidos títulos de EA Play, Xbox y ventajas
                                premium Riot Games
                              </li>
                              <li>
                                <img
                                  src={`${process.env.NEXT_PUBLIC_CDN}/estaticos/img/check-regular.svg`}
                                />{' '}
                                Sin permanencia
                              </li>
                            </ul>
                            <ButtonLayout>
                              <ButtonPrimary
                                className="btn100pct tealium_clic_PA-gaming-prueba-un-mes-gratis"
                                href="https://www.movistar.es/mimovistar-cliente/publico/acceso/privado/procesoCompraGamePassTelco?buyProcess=gamepass&alias=xbox-game-pass-stand-alone&productOffering=2269"
                              >
                                Prueba un mes gratis
                              </ButtonPrimary>
                            </ButtonLayout>
                          </Stack>
                        }
                      ></GridLayout>{' '}
                    </Stack>
                  </Stack>
                </Box>
              </ResponsiveLayout>
            </div>
          </ResponsiveLayout>

          <ResponsiveLayout>
            <Box paddingY={isDesktopOrBigger ? 96 : 24}>
              <Stack space={24}>
                <Text6 textAlign="center" as="h2">
                  También te puede interesar...
                </Text6>
                <Text2 textAlign="center" as="p">
                  Artículos relacionados con tu <b>Xbox Series X</b>
                </Text2>
                <Stack space={0}>
                  <div>
                    <Carousel
                      withBullets
                      itemsPerPage={{ desktop: 4 }}
                      items={others.map((item, i) => (
                        <MediaCard
                          key={i}
                          headline={item['tagsdef'].map((tag, x) => tag)}
                          pretitle=""
                          title={item['name']}
                          subtitle={
                            <Text2
                              color={skinVars.colors.textSecondary}
                              color={skinVars.colors.textSecondary}
                            >
                              {item['descripcion']}
                            </Text2>
                          }
                          description={
                            <div>
                              <Text2>Desde</Text2>
                              <br />
                              <Text4 color={skinVars.colors.textSecondary}>
                                <s>{item['precioOriginal']}€</s>
                              </Text4>{' '}
                              <Text5>{item['precio']}€</Text5>
                              <Text2>/mes</Text2>
                              <br />
                              <Text2 color={skinVars.colors.textSecondary}>
                                con miMovistar
                              </Text2>
                            </div>
                          }
                          media={
                            <img
                              src={item['image']}
                              style={{
                                maxHeight: '180px',
                                objectFit: 'contain',
                                padding: '10px 0',
                                backgroundColor: '#ccc',
                              }}
                            />
                          }
                          button={
                            <ButtonPrimary
                              small
                              href={item['url']}
                              className={item['classloquiero']}
                            >
                              ¡Lo quiero!
                            </ButtonPrimary>
                          }
                          buttonLink={item['moreinfo']}
                        />
                      ))}
                    />
                  </div>
                </Stack>
              </Stack>
            </Box>
          </ResponsiveLayout>
          <div id="sticky_div">
            <ResponsiveLayout>
              <ButtonLayout>
                <ButtonPrimary
                  href={
                    'https://www.movistar.es/particulares/mimovistar/elige-dispositivo?deviceType=gaming&flyOutAlias=ntt_xbox series x-fifa2023-ds-gt7-ultimate-spiderman-fusion'
                  }
                  className={
                    'tealium_clic_PA-gaming-sony-xbox series x-god-of-war-loquiero-sticky createstat'
                  }
                >
                  Lo quiero!
                </ButtonPrimary>
              </ButtonLayout>
            </ResponsiveLayout>
          </div>
          <style global jsx>{`
            @font-face {
              font-family: 'OnAir';
              font-style: normal;
              font-weight: 300;
              src: url('${process.env
                  .NEXT_PUBLIC_CDN}/estaticos/fonts/OnAir-Light.woff2')
                format('woff2');
            }
            @font-face {
              font-family: 'OnAir';
              font-style: normal;
              font-weight: 400;
              src: url('${process.env
                  .NEXT_PUBLIC_CDN}/estaticos/fonts/OnAir-Regular.woff2')
                format('woff2');
            }
            @font-face {
              font-family: 'OnAir';
              font-style: normal;
              font-weight: 500;
              src: url('${process.env
                  .NEXT_PUBLIC_CDN}/estaticos/fonts/OnAir-Regular.woff2')
                format('woff2');
            }
            @font-face {
              font-family: 'OnAir';
              font-style: normal;
              font-weight: 700;
              src: url('${process.env
                  .NEXT_PUBLIC_CDN}/estaticos/fonts/OnAir-Bold.woff2')
                format('woff2');
            }

            body {
              font-family: 'OnAir', 'Helvetica', 'Arial', sans-serif;
            }

            ._3dl29l3{
              z-index: 100;
            }

            .headbanner {
              background-color: #0b2739;
              padding-bottom: 0px;
            }

            .techTable {
              margin: 0 auto;
              width: 100%;
              max-width: 800px;
            }

            .text-left {
              text-align: left;
            }

            .dialogresp {
              max-height: calc(100vh - 64px);
            }

            .dialogresp button {
              display: none;
            }

            .bannerimage > div:last-child {
              display: none;
            }

            .techTableRow {
              grid-template-columns: 1fr 1fr;
            }

            .groupCards {
              max-width: 600px;
              width: 100%;
              margin: 0 auto;
            }

            .carrouselincluye img {
              opacity: 1 !important;
            }

            .carrouselincluye * {
              justify-content: center;
            }

            .carrouselincluye
              > div
              > div
              > div
              > div
              div:has(div[data-component-name]) {
              justify-content: left;
            }

            #sticky_div {
              position: fixed;
              bottom: 0;
              background: #fff;
              /*background: linear-gradient(180deg, rgba(10,38,56,0) 0%, rgba(10,38,56,1) 60%, rgba(10,38,56,1) 100%);*/
              left: 0;
              width: 100%;
              text-align: center;
              padding: 15px 0;
              box-shadow: 0px 0px 30px 0px rgba(10, 38, 56, 0.6);
              transform: translateY(200px);
              transition: 750ms;
              z-index: 4000;
            }

            #sticky_div.active {
              transform: translateY(1px);
            }

            #sticky_div div {
              justify-content: center;
            }

            .grid2hidden > div:last-child {
              display: none;
            }

            .poster3 {
              display: grid;
              gap: 16px;
              max-width: 900px;
              margin: 0 auto;
              grid-template-columns: 1fr 1fr 1fr;
            }

            .poster3 ul {
              margin-left: 30px;
              list-style: disc;
            }

            .preciotabs div {
              justify-content: center;
            }

            .preciotabs button {
              flex: 0 1 370px;
              max-width: 370px;
            }

            .topbutton {
              margin-top: 40px;
            }

            .mt24 {
              margin-top: 24px;
            }

            .imgcard {
              border-radius: 12px;
            }

            .listxgpu li {
              display: flex;
              gap: 8px;
              padding-bottom: 12px;
            }

            .preciotabsguia {
              position: relative;
            }

            .preciotabsguia .guia {
              position: absolute;
              top: -30px;
              left: 0;
            }

            @media only screen and (max-width: 760px) {
              .grid4 {
                grid-template-columns: 1fr;
                display: grid;
                grid-auto-flow: unset;
                gap: 40px;
              }

              .grid4 > div:not(:empty) ~ div:not(:empty) {
                margin-left: 0;
              }

              .grid4 .text-left {
                text-align: center;
              }

              .gridbanner {
                overflow: hidden;
              }

              .griditem0 {
                padding-left: 16px;
                padding-right: 16px;
              }

              .griditem1 {
                padding-right: 16px;
              }

              .gridbanner > div > div:first-child {
                order: 2;
              }

              .gridbanner > div > div:last-child {
                order: 1;
              }

              .bannerimage > div {
                display: none;
              }

              .bannerimage > div:last-child {
                display: block;
                height: auto;
              }

              .responsivelayout > div {
                width: 100%;
                margin: 0;
              }

              .poster3 {
                grid-template-columns: 1fr;
                grid-auto-flow: unset;
              }

              .preciotabs button span {
                font-size: 13px;
                line-height: 15px;
              }

              .inversemob > div > div > div:first-child {
                order: 1;
                padding-top: 60px;
              }

              .inversemob > div > div > div:last-child {
                order: 0;
              }

              .topbutton {
                margin-top: 20px;
                margin-bottom: 20px;
              }
              .preciotabsguia .guia {
                top: -90px;
              }

              .carrouselincluye * {
                justify-content: initial;
              }

              .carrouselincluye
                > div
                > div
                > div
                > div
                div:has(div[data-component-name]) {
                justify-content: initial;
              }

              .carrouselincluye > div > div:last-child > div {
                justify-content: center;
              }
            }
          `}</style>
        </div>
      </>
      <Footer />
    </>
  );
};

export default SeriesX;

export const getStaticProps = wrapper.getStaticProps(async ({ store }) => {
  const modules = await Promise.all([
    await import('@gerenciatd/next13.adabyron.misc.get-static-content'),
    await import('@gerenciatd/next13.normalizers.components-header.sections'),
    await import(
      '@gerenciatd/next13.normalizers.components-header.breadcrumbs'
    ),
    await import(
      '@gerenciatd/next.app-controller.reducers-sagas.header-reducer-r'
    ),
    await import("@gerenciatd/next13.adabyron.custo.get-seo"),
  ]);

  const getStaticContent = modules[0].default;
  const getHeaderSections = modules[1].default;
  const getBreadcrumbs = modules[2].default;
  const headerActions = modules[3].actions;
  const getSeo = modules[4].default;

  const { context } = store.getState().main;

  const seoInfo = await getSeo({
    context,
    location: `www.movistar.es/particulares/gaming/xbox-x-series`,
  });

  // HEADER USUAL PROPS
  const urlBreadcrumbs = '/static/json/header/breadcrumbs.json';
  const breadcrumbsInfoJson = await getStaticContent({
    resourcePath: urlBreadcrumbs,
    context,
  });
  const url = '/particulares/gaming/xbox-x-series';
  const breadcrumbsProps = getBreadcrumbs(breadcrumbsInfoJson, url);
  const headerInfoJson = await getStaticContent({
    resourcePath: '/static/json/header/header_plan_r.json',
    context,
  });
  // HEADER REDUX PROPS
  const headerProps = getHeaderSections(headerInfoJson, breadcrumbsProps);
  store.dispatch(headerActions.setupHeaderProps(headerProps));
  store.dispatch(
    headerActions.getFooterInfo({
      pathname: '/particulares/gaming/xbox-x-series',
    })
  );

  store.dispatch(END);
  await store.sagaTask.toPromise();

  return {
    props: {
      headerProps,
      breadcrumbsProps,
      seoInfo,
    },
  };
});
